import { render, staticRenderFns } from "./nomenuPage.vue?vue&type=template&id=bed6c654&scoped=true&"
import script from "./nomenuPage.vue?vue&type=script&lang=js&"
export * from "./nomenuPage.vue?vue&type=script&lang=js&"
import style0 from "./nomenuPage.vue?vue&type=style&index=0&id=bed6c654&prod&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed6c654",
  null
  
)

export default component.exports